module.exports = __webpack_public_path__ + "static/media/Rectangle 60.57b14789.png";